module.exports = __webpack_public_path__ + "src/assets/img/share/tips/nervousness/01a01ec58e8c6ded6e100f19947de034.png";